import { formatIDR } from "../../lib/api";

export const rp = formatIDR;
export const CATEGORIES = ["All", "Ring", "Earring", "Necklace", "Bracelet", "Set"];

export function category(name) {
    const n = (name || "").toLowerCase();
    if (/earring|anting/.test(n)) return "Earring";
    if (/necklace|kalung|pendant|liontin/.test(n)) return "Necklace";
    if (/bracelet|gelang|bangle/.test(n)) return "Bracelet";
    if (/\bset\b/.test(n)) return "Set";
    if (/\bring\b|cincin/.test(n)) return "Ring";
    return "Other";
}

export function groupItems(items) {
    const map = new Map();
    for (const it of items) {
        const k = it.item_group_id ?? `i${it.item_id}`;
        if (!map.has(k)) map.set(k, { key: String(k), title: it.group_name || it.name, cat: category(it.group_name || it.name), items: [] });
        map.get(k).items.push(it);
    }
    return [...map.values()].sort((a, b) => a.title.localeCompare(b.title));
}

export const matches = (it, q) =>
    [it.barcode, it.sku, it.name, it.variant, it.group_name].some((v) => v && String(v).toLowerCase().includes(q));

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export const SYNC_LABEL = { SAVED: "Saved", PENDING: "Waiting to Sync", SYNCED: "Synced", REJECTED: "Needs Review" };
export const SYNC_TONE = { SAVED: "text-amber-700", PENDING: "text-amber-700", SYNCED: "text-sage-dark", REJECTED: "text-red-700" };
export const RECEIPT_LABEL = { PENDING: "Pending", SENDING: "Sending", SENT: "Sent", FAILED: "Failed" };
export const RECEIPT_TONE = { PENDING: "text-amber-700", SENDING: "text-amber-700", SENT: "text-sage-dark", FAILED: "text-red-700" };

// Customer stats = server totals (synced sales) + this device's unsynced sales.
export function customerStats(c, txns) {
    const own = txns.filter((t) => t.customer_wa === c.wa && t.sync_status !== "SYNCED" && t.sync_status !== "REJECTED");
    const last = [c.server_last_purchase_at, ...own.map((t) => t.created_at)].filter(Boolean).sort().pop() || null;
    return { count: (c.server_total_purchases || 0) + own.length, spent: (c.server_total_spent || 0) + own.reduce((s, t) => s + t.total, 0), last };
}
